export default __webpack_public_path__ + "static/media/icon-voucher-categories.4369165b.svg";